export default __webpack_public_path__ + "static/media/EventsandFestivals.00f02a54.jpeg";